import React from "react";
import { IconProps, iconPropTypes } from "./IconProps";

const PhoneIcon: React.FC<IconProps> = ({
  fill = "",
  width = 32,
  height = 32,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M27.7963 19.8075L21.9075 17.1687L21.8913 17.1612C21.5856 17.0305 21.2521 16.978 20.921 17.0086C20.5899 17.0391 20.2716 17.1517 19.995 17.3362C19.9624 17.3578 19.9311 17.3811 19.9013 17.4062L16.8588 20C14.9313 19.0637 12.9413 17.0887 12.005 15.1862L14.6025 12.0975C14.6275 12.0662 14.6513 12.035 14.6738 12.0012C14.8543 11.7254 14.9638 11.4091 14.9926 11.0807C15.0214 10.7523 14.9686 10.4218 14.8388 10.1187V10.1037L12.1925 4.20499C12.0209 3.80907 11.7259 3.47926 11.3515 3.26479C10.9771 3.05032 10.5433 2.96269 10.115 3.01499C8.42122 3.23787 6.86649 4.0697 5.74118 5.35511C4.61587 6.64052 3.99695 8.2916 4.00001 9.99999C4.00001 19.925 12.075 28 22 28C23.7084 28.0031 25.3595 27.3841 26.6449 26.2588C27.9303 25.1335 28.7621 23.5788 28.985 21.885C29.0374 21.4568 28.95 21.0232 28.7357 20.6488C28.5215 20.2744 28.1919 19.9793 27.7963 19.8075ZM22 26C17.758 25.9954 13.691 24.3082 10.6914 21.3086C7.69184 18.309 6.00464 14.242 6.00001 9.99999C5.99531 8.77935 6.43507 7.59874 7.23718 6.67862C8.03929 5.75851 9.14889 5.16182 10.3588 4.99999C10.3583 5.00498 10.3583 5.01 10.3588 5.01499L12.9838 10.89L10.4 13.9825C10.3738 14.0127 10.35 14.0448 10.3288 14.0787C10.1407 14.3674 10.0303 14.6997 10.0084 15.0436C9.9865 15.3874 10.0538 15.7311 10.2038 16.0412C11.3363 18.3575 13.67 20.6737 16.0113 21.805C16.3237 21.9536 16.6694 22.0185 17.0144 21.9935C17.3595 21.9686 17.6922 21.8545 17.98 21.6625C18.0121 21.6409 18.043 21.6175 18.0725 21.5925L21.1113 19L26.9863 21.6312C26.9863 21.6312 26.9963 21.6312 27 21.6312C26.8402 22.8428 26.2444 23.9547 25.3241 24.7588C24.4038 25.5628 23.2221 26.0041 22 26Z" />
  </svg>
);

PhoneIcon.propTypes = iconPropTypes;

export default PhoneIcon;
